import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.device_nm = ''
      this.report_type = ''
    }
  }
}
export default searchFrom
